import React from 'react'
import { Collapse } from 'react-bootstrap'
import { ArrowIcon } from '../Icons/ArrowIcon'
import { colors } from '../../styles/colors'
import styled from 'styled-components'
import { useLocalReceiptsState } from '../../stores/LocalReceiptsProvider'
import { StyledItemWrapper } from '../TreeList/treeList'
import { useTranslation } from 'react-i18next'
import StorehouseFilter from '../Filter/StorehouseFilter'
import SupplierFilter from '../Filter/SupplierFilter'
import DateRangeFilter from '../Filter/DateRangeFilter'

const StyledCollapseWrapper = styled.div`
  margin-bottom: 25px;
 

  ${StyledItemWrapper} {
    background-color: #FFF;
  }

`

const StyledFilterToggle = styled.h2`
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${colors.gray5};
  font-size: 20px;
  margin-bottom: 10px;
  ${ArrowIcon} {
    margin-right: 10px;
  }
`

const OverlayLeftFilter = () => {
  const {
    openSupplierFilter, setOpenSupplierFilter,
    openStorehouseFilter, setOpenStorehouseFilter,
    supplierFilter, setSupplierFilter,
    storehouseFilter, setStorehouseFilter,
    openDateRangeFilter, setOpenDateRangeFilter,
    startDateFilter, setStartDateFilter,
    endDateFilter, setEndDateFilter,
  } = useLocalReceiptsState()
  const { t } = useTranslation()
  return (
    <>
    <StyledCollapseWrapper>
        <StyledFilterToggle onClick={() => setOpenStorehouseFilter(!openStorehouseFilter)}
            aria-controls="storehouse-collapse" aria-expanded={openStorehouseFilter}>
            <ArrowIcon variant={openStorehouseFilter ? 'down' : 'right'} color={colors.gray5} />{t('goodsReceiptsTable:warehouse')} ({t('goodsReceiptsTable:warehouseShortcut')})
        </StyledFilterToggle>
        <Collapse in={openStorehouseFilter}>
            <div id="storehouse-collapse">
            <StorehouseFilter storehouseFilter = {storehouseFilter} setStorehouseFilter = {setStorehouseFilter}/>
            </div>
        </Collapse>
    </StyledCollapseWrapper>
    <StyledCollapseWrapper>
        <StyledFilterToggle onClick={() => setOpenSupplierFilter(!openSupplierFilter)}
          aria-controls="supplier-collapse" aria-expanded={openSupplierFilter}>
          <ArrowIcon variant={openSupplierFilter ? 'down' : 'right'} color={colors.gray5} />{t('goodsReceiptsTable:supplier')} ({t('goodsReceiptsTable:supplierShortcut')})
        </StyledFilterToggle>
        <Collapse in={openSupplierFilter}>
          <div id="supplier-collapse">
            <SupplierFilter supplierFilter = {supplierFilter} setSupplierFilter = {setSupplierFilter}/>
          </div>
        </Collapse>
      </StyledCollapseWrapper>
      <StyledCollapseWrapper>
        <StyledFilterToggle onClick={() => setOpenDateRangeFilter(!openDateRangeFilter)}
          aria-controls="dateRange-collapse" aria-expanded={openDateRangeFilter}>
          <ArrowIcon variant={openDateRangeFilter ? 'down' : 'right'} color={colors.gray5} />{t('goodsReceiptsTable:expectedTimeOfArrival')}
        </StyledFilterToggle>
        <Collapse in={openDateRangeFilter}>
          <div id="dateRange-collapse">
            <DateRangeFilter dateFrom = {startDateFilter} setDateFrom = {setStartDateFilter} dateTo = {endDateFilter} setDateTo = {setEndDateFilter}/>
          </div>
        </Collapse>
      </StyledCollapseWrapper>
    </>
  )
}

export default OverlayLeftFilter
